<template>
  <div v-loading="loading">
    <div class="title">任务详情</div>
    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">基本信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="basic-info">
            <span class="label">题目编号：</span>
            <span>{{ taskInfo.id }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="basic-info">
            <span class="label">价格：</span>
            <span>¥ {{ taskInfo.unit_price }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="basic-info" @click="descriptionVisible = true">
            <span class="label">任务说明：</span>
            <el-link type="primary">查看</el-link>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="basic-info">
            <span class="label">状态：</span>
            <span>{{ taskInfo.status_label }}</span>
          </div>
        </el-col>
      </el-row>
      <div class="basic-info">
        <span class="label">关联岗位：</span>
        <el-tag size="small" v-if="taskInfo.skill_model.industry_job">
          {{ taskInfo.skill_model.industry_job.name }}
        </el-tag>
        <span v-else> - </span>
      </div>
    </el-card>

    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">岗位标准</span>
      </div>
      <Markdown
        class="w-95pc"
        style="margin: 0 auto"
        :value.sync="md"
        space="_for_post_sub_project"
        folder="fuwu"
        :defaultOpen="disabled ? 'preview' : 'edit'"
        :disabled="disabled"
        :option="!disabled ? 'assign_topic' : 'readmodel'"
      ></Markdown>
    </el-card>

    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">对工作者的要求</span>
      </div>
      <div class="basic-info">
        <span class="label">技能模型：</span>
        <el-input
          class="w-400 mb-12"
          v-model="taskInfo.skill_model.name"
          size="small"
          placeholder="请输入技能模型名称"
          clearable
          :disabled="disabled"
        ></el-input>
      </div>
      <div class="basic-info">
        <span class="label">描述：</span>
        <el-input
          class="w-400 mb-12"
          v-model="description"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 5 }"
          :resize="disabled ? 'none' : ''"
          size="small"
          placeholder="请输入技能模型描述"
          :disabled="disabled"
        ></el-input>
      </div>
      <div class="model-framework-container">
        <el-divider>模型框架</el-divider>
        <div class="model-framework-btn">
          <div>
            <zhu-button
              v-if="!disabled"
              text="编辑技能点"
              :shadow="true"
              size="mini"
              type="primary"
              @click="editPointInfo"
            >
            </zhu-button>
            <zhu-button
              v-if="!disabled"
              class="ml-12"
              text="编辑级别"
              :shadow="true"
              size="mini"
              type="primary"
              @click="editLevelInfo"
            >
            </zhu-button>
          </div>
          <div>
            <el-button size="mini" plain @click="standardVisible = true"
              >标准定义</el-button
            >
            <div class="fullscreen-icon-container" @click="fullscreen">
              <i class="el-icon-full-screen fullscreen-icon"></i>
            </div>
          </div>
        </div>
        <div class="model-framework-content">
          <el-table
            border
            :data="taskInfo.list"
            :span-method="objectSpanMethod"
          >
            <el-table-column label="技能点 & 重要度">
              <el-table-column width="150" label="分组">
                <template slot-scope="scope">
                  <div class="cell-content">{{ scope.row.groupName }}</div>
                </template>
              </el-table-column>
              <el-table-column width="150" label="技能点">
                <template slot-scope="scope">
                  <div
                    class="cell-content"
                    :class="backgroundColor(scope.row.important_score)"
                  >
                    {{ scope.row.name }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="80" label="重要度">
                <template slot-scope="scope">
                  <div v-if="disabled">
                    <div
                      class="important_score-background"
                      :class="backgroundColor(scope.row.important_score)"
                      :style="`width: ${scope.row.important_score}%`"
                    ></div>
                    <div class="important_score-content">
                      {{ scope.row.important_score }}
                    </div>
                  </div>
                  <el-input
                    v-else
                    v-model="scope.row.important_score"
                    size="mini"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="80" label="状态" v-if="false">
                <template slot-scope="scope">
                  <div style="text-align: center">
                    <div v-if="scope.row.status === 1">
                      <span class="badge-status success"></span>
                      <span>已上架</span>
                    </div>
                    <div v-else-if="scope.row.status === 2">
                      <span class="badge-status warning"></span>
                      <span>未上架</span>
                    </div>
                    <div v-else>
                      <span class="badge-status info"></span>
                      <span>无题目</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="65" label="是否必测项">
                <template slot-scope="scope">
                  <div style="text-align: center">
                    <el-switch
                      v-model="scope.row.is_need_test"
                      :disabled="disabled"
                    ></el-switch>
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="级别 & 技能要求">
              <el-table-column
                v-for="(item, levelIndex) in taskInfo.levels"
                :key="levelIndex"
                :label="item.name"
              >
                <el-table-column
                  v-for="(data, sublevelIndex) in item.children"
                  :key="sublevelIndex"
                  :label="data.name"
                >
                  <template slot-scope="scope">
                    <div
                      v-for="(score, index) in scope.row.level_scores"
                      :key="index"
                    >
                      <div v-if="score.level_id === data.level_id">
                        <div
                          v-if="disabled"
                          class="cell-content"
                          :class="scoreColor[score.score]"
                          style="text-align: center"
                        >
                          {{ score.score }}
                        </div>
                        <el-autocomplete
                          v-else
                          v-model="score.score"
                          size="mini"
                          :fetch-suggestions="querySearch"
                        ></el-autocomplete>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-card>

    <el-dialog
      title="编辑技能点"
      :visible.sync="pointVisible"
      width="950px"
      :before-close="clearPointInfo"
      center
    >
      <el-form
        class="dialog-info"
        label-width="85px"
        :model="pointInfo"
        ref="pointInfo"
      >
        <el-button size="mini" @click="addPoint">添加分组</el-button>
        <div class="dialog-list">
          <el-card
            v-for="(item, index) in pointInfo.groups"
            :key="index"
            class="dialog-item w-49pc"
            shadow="hover"
          >
            <el-link
              class="dialog-item-delete"
              icon="el-icon-delete"
              :underline="false"
              type="danger"
              @click="del(pointInfo.groups, index)"
            ></el-link>
            <div>
              <el-form-item
                label="分组名称"
                :prop="`groups[${index}].name`"
                :rules="{ required: true, trigger: 'blur' }"
                :show-message="false"
              >
                <el-input
                  class="w-95pc"
                  v-model="item.name"
                  size="small"
                  placeholder="请输入分组名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item
                label="技能点"
                :prop="`groups[${index}].point_ids`"
                :rules="{ required: true, trigger: 'blur' }"
                :show-message="false"
              >
                <el-select
                  class="w-95pc"
                  v-model="item.point_ids"
                  size="small"
                  multiple
                  filterable
                  remote
                  clearable
                  placeholder="请选择技能点"
                  :remote-method="remoteMethod"
                  :loading="selectLoading"
                >
                  <el-option
                    v-for="point in skill_points"
                    :key="point.id"
                    :label="point.name"
                    :value="point.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-card>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearPointInfo">取 消</el-button>
        <el-button type="primary" @click="savePointInfo" :loading="btnLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="编辑级别"
      :visible.sync="levelVisible"
      width="950px"
      :before-close="clearLevelInfo"
      center
    >
      <el-form
        class="dialog-info"
        label-width="90px"
        :model="levelInfo"
        ref="levelInfo"
      >
        <el-button size="mini" @click="addLevelCard">添加等级</el-button>
        <div class="dialog-list">
          <el-card
            v-for="(item, index) in levelInfo.levels"
            :key="index"
            class="dialog-item w-49pc"
            shadow="hover"
          >
            <el-link
              class="dialog-item-delete"
              icon="el-icon-delete"
              :underline="false"
              type="danger"
              @click="del(levelInfo.levels, index)"
            ></el-link>
            <el-form-item
              :label="`等级 ${index + 1}：`"
              :prop="`levels[${index}].name`"
              :rules="{ required: true, trigger: 'blur' }"
              :show-message="false"
            >
              <el-input
                class="w-90pc"
                v-model="item.name"
                size="small"
                :placeholder="`请输入等级 ${index + 1} 的名称`"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="子等级："
              :prop="`levels[${index}].children`"
              :rules="{ required: true, trigger: 'blur' }"
              :show-message="false"
            >
              <el-button size="mini" @click="addLevel(item.children)"
                >添加子等级</el-button
              >
              <div v-for="(data, subindex) in item.children" :key="subindex">
                <el-form-item
                  :prop="`levels[${index}].children[${subindex}].name`"
                  :rules="{ required: true, trigger: 'blur' }"
                  :show-message="false"
                >
                  <el-input
                    class="w-90pc"
                    v-model="data.name"
                    size="small"
                    :placeholder="`请输入子等级 ${subindex + 1} 的名称`"
                    clearable
                  ></el-input>
                  <el-link
                    class="ml-8"
                    icon="el-icon-delete"
                    :underline="false"
                    type="danger"
                    @click="del(item.children, subindex)"
                  ></el-link>
                </el-form-item>
              </div>
            </el-form-item>
          </el-card>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearLevelInfo">取 消</el-button>
        <el-button type="primary" @click="saveLevelInfo" :loading="btnLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="标准定义"
      :visible.sync="standardVisible"
      width="450px"
      center
    >
      <div style="min-height: 260px">
        <div class="flex mb-12">
          <div class="flex-label">重要度（技能点）：</div>
          <div class="flex-1 ml-12">0 ～ 100</div>
        </div>
        <div class="flex">
          <div class="flex-label">掌握度（技能要求）：</div>
          <div class="flex-1 ml-12">0 - 不要求</div>
        </div>
        <div class="flex">
          <div class="flex-label"></div>
          <div class="flex-1 ml-12">1 - 了解</div>
        </div>
        <div class="flex">
          <div class="flex-label"></div>
          <div class="flex-1 ml-12">2 - 熟悉</div>
        </div>
        <div class="flex">
          <div class="flex-label"></div>
          <div class="flex-1 ml-12">3 - 掌握</div>
        </div>
        <div class="flex">
          <div class="flex-label"></div>
          <div class="flex-1 ml-12">4 - 精通</div>
        </div>
        <div class="flex">
          <div class="flex-label"></div>
          <div class="flex-1 ml-12">5 - 专家</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      class="skill-task-dialog"
      :visible.sync="descriptionVisible"
      width="1000px"
      :show-close="false"
      center
    >
      <markdown-it :md="taskInfo.description"></markdown-it>
    </el-dialog>

    <div
      style="text-align: right;"
      class="mt-12"
      v-if="
        taskInfo.status == 1 &&
          !loading &&
          authPermissions.includes(
            'kcell.api.jiker.fuwu_admin.skill_model_tasks.update'
          )
      "
    >
      <el-popconfirm
        class="mr-12"
        title="提交后不能再修改，是否提交？"
        @onConfirm="submit"
      >
        <el-button type="primary" class="ml-12" slot="reference"
          >提交</el-button
        >
      </el-popconfirm>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import screenfull from "screenfull";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import Markdown from "@/components/Markdown";
import postService from "@/global/service/post";
import kcellService from "@/global/service/kcell";

export default {
  components: {
    Markdown,
    MarkdownIt
  },
  data() {
    return {
      loading: true,
      btnLoading: false,
      selectLoading: false,
      disabled: false,
      scoreColor: {
        "0": "old-lace",
        "1": "yellow",
        "2": "light-green",
        "3": "light-sky-blue",
        "4": "violet",
        "5": "deep-pink"
      },
      taskInfo: {
        id: 4,
        description: "专项分析和数据挖掘处理，为业务决策提供数据支持依据",
        unit_price: "¥ 1234.00",
        status: 1,
        status_label: "建设中",
        skill_model: {
          name: "Node.js工程师 技能模型",
          description: "描述",
          industry_job: {
            id: 70,
            name: "IT&互联网 >> 技术研发岗 >> 前端方向 >> Node.js工程师"
          }
        },
        list: [],
        groups: [],
        levels: []
      },
      md: "",
      description: "",
      skill_points: [],
      pointVisible: false,
      pointInfo: {
        groups: []
      },
      levelVisible: false,
      descriptionVisible: false,
      levelInfo: {
        levels: []
      },
      standardVisible: false
    };
  },
  computed: {
    ...mapState(["authPermissions"]),
    backgroundColor() {
      return function(important_score) {
        const score = Number(important_score);
        if (score === 0) return "old-lace";
        if (score > 0 && score <= 20) return "yellow";
        if (score > 20 && score <= 40) return "light-green";
        if (score > 40 && score <= 60) return "light-sky-blue";
        if (score > 60 && score <= 80) return "violet";
        return "deep-pink";
      };
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      this.loading = true;
      postService
        .postShow(id)
        .then(res => {
          this.skill_model_id = res.skill_model.id;
          this.getSkillModelData(res.skill_model.id);
          this.taskInfo = res;
          this.taskInfo.list = [];
          const groups = res.skill_model.level_score.groups;
          const heading = res.skill_model.level_score.heading;
          this.taskInfo.skill_model.industry_job.standard = this.taskInfo
            .skill_model.industry_job.standard
            ? this.taskInfo.skill_model.industry_job.standard
            : "";
          this.md = this.md
            ? this.md
            : this.taskInfo.skill_model.industry_job.standard;
          this.description = this.description
            ? this.description
            : this.taskInfo.skill_model.description;
          this.disabled = res.status == 1 ? false : true;
          groups.forEach(data => {
            data.stacks.forEach(item => {
              item.scores = [];
              heading.levels.forEach(level => {
                level.children.forEach(sublevel => {
                  item.scores.push({
                    level_id: sublevel.level_id,
                    score: "0"
                  });
                });
              });
              item.level_scores.forEach(subitem => {
                item.scores.forEach(score => {
                  if (subitem.level_id === score.level_id) {
                    score.score = String(subitem.score);
                  }
                });
              });
              this.taskInfo.list.push({
                uid: item.id,
                id: item.stack.id,
                name: item.stack.name,
                important_score: item.important_score,
                level_scores: item.scores,
                groupId: data.id,
                groupName: data.name,
                is_need_test: item.is_need_test
              });
            });
          });

          return heading.levels;
        })
        .then(levels => {
          if (levels.length !== 0) {
            this.taskInfo.levels = levels;
            this.loading = false;
          } else {
            postService
              .postSkillLevelEdit(
                { id },
                {
                  levels: [{ name: "等级 1", children: [{ name: "子等级 1" }] }]
                }
              )
              .then(() => {
                this.getData();
              });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSkillModelData(id) {
      Promise.all([postService.postGroupStacks(id)]).then(([groupStacks]) => {
        this.taskInfo.groups = groupStacks.groups.map(data => {
          data.stacks.forEach(item => {
            if (this.skill_points.length === 0) {
              this.skill_points.push(item.stack);
            } else {
              let noRepeat = true;
              this.skill_points.forEach(point => {
                if (point.id === item.stack.id) noRepeat = false;
              });
              if (noRepeat) {
                this.skill_points.push(item.stack);
              }
            }
          });
          return data;
        });
      });
    },
    fullscreen() {
      if (screenfull.isEnabled) {
        screenfull.request(
          document.getElementsByClassName("model-framework-content")[0]
        );
      }
    },
    querySearch(queryString, cb) {
      cb([
        { value: "0" },
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]);
    },
    editPointInfo() {
      this.pointVisible = true;
      this.skill_points_init = JSON.parse(JSON.stringify(this.skill_points));
      if (this.taskInfo.groups && this.taskInfo.groups.length !== 0) {
        this.pointInfo.groups = this.taskInfo.groups.map(data => {
          return {
            id: data.id,
            name: data.name,
            stacks: data.stacks.map(item => {
              return {
                id: item.id,
                stack_id: item.stack.id
              };
            }),
            point_ids: data.stacks.map(item => item.stack.id)
          };
        });
      } else {
        this.pointInfo.groups = [{ name: "", point_ids: [] }];
      }
    },
    savePointInfo() {
      this.$refs["pointInfo"].validate(val => {
        if (!val) {
          this.$message.error("缺少必要参数");
          return;
        }
        const id = this.skill_model_id;
        const groups = this.pointInfo.groups.map(data => {
          const stacks = data.point_ids.map(item => {
            return {
              stack_id: item
            };
          });
          if (data.stacks) {
            stacks.forEach(item => {
              data.stacks.forEach(subitem => {
                if (item.stack_id === subitem.stack_id) {
                  item.id = subitem.id;
                }
              });
            });
          }
          return {
            id: data.id || null,
            name: data.name,
            description: "无",
            stacks
          };
        });
        this.btnLoading = true;
        postService
          .postGroupStacksEdit(id, { groups: groups })
          .then(() => {
            this.$message.success("更新技能点成功");
            this.clearPointInfo();
            this.getData();
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    clearPointInfo() {
      this.$refs["pointInfo"].clearValidate();
      this.skill_points = JSON.parse(JSON.stringify(this.skill_points_init));
      this.pointVisible = false;
    },
    editLevelInfo() {
      this.levelVisible = true;
      this.levelInfo.levels = this.taskInfo.levels.map(data => {
        return {
          id: data.level_id,
          name: data.name,
          children: data.children.map(item => {
            return {
              id: item.level_id,
              name: item.name
            };
          })
        };
      });
    },
    saveLevelInfo() {
      this.$refs["levelInfo"].validate(val => {
        if (!val) {
          this.$message.error("缺少必要参数");
          return;
        }
        const id = this.skill_model_id;
        this.btnLoading = true;
        postService
          .postSkillLevelEdit(id, { levels: this.levelInfo.levels })
          .then(() => {
            this.getData();
            this.$message.success("更新级别成功");
            this.clearLevelInfo();
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    clearLevelInfo() {
      this.$refs["levelInfo"].clearValidate();
      this.levelVisible = false;
    },
    addPoint() {
      this.pointInfo.groups.push({ name: "", point_ids: [] });
    },
    addLevelCard() {
      this.levelInfo.levels.push({ name: "", children: [{ name: "" }] });
    },
    addLevel(arr) {
      arr.push({ name: "" });
    },
    del(arr, index) {
      if (arr.length === 1) {
        this.$message.error("数量不得少于1个");
        return;
      } else {
        arr.splice(index, 1);
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.selectLoading = true;
        kcellService
          .kcellSkills({ name: query })
          .then(res => {
            this.skill_points = res;
          })
          .finally(() => {
            this.selectLoading = false;
          });
      } else {
        this.skill_points = [];
      }
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const prevRow = this.taskInfo.list[rowIndex - 1];
        if (row.groupId !== (prevRow || {}).groupId) {
          const rowCount = this.taskInfo.list.reduce((ret, data) => {
            if (data.groupId === row.groupId) {
              ret++;
            }
            return ret;
          }, 0);
          return {
            rowspan: rowCount,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    submit() {
      if (this.loading || this.btnLoading) return;
      if (!this.md) {
        this.$message.error("请填写岗位标准");
        return;
      }
      if (!this.description) {
        this.$message.error("请填写技能模型描述");
        return;
      }
      const id = this.$route.params.id;
      const skill_model = {
        name: this.taskInfo.skill_model.name,
        description: this.description,
        job: {
          standard: this.md
        }
      };
      const ids = [];
      this.taskInfo.list.forEach(data => {
        if (ids.indexOf(data.groupId) === -1) {
          ids.push(data.groupId);
        }
      });
      const groups = ids.map(data => {
        return {
          id: data,
          stacks: []
        };
      });
      this.taskInfo.list.forEach(data => {
        groups.forEach(item => {
          if (data.groupId === item.id) {
            item.stacks.push({
              id: data.uid,
              important_score: Number(data.important_score),
              level_scores: data.level_scores,
              is_need_test: data.is_need_test
            });
          }
        });
      });
      if (!groups.length) {
        this.$message.error("请填写技能点");
        return;
      }
      this.btnLoading = true;
      postService
        .postEdit(id, { skill_model, groups })
        .then(() => {
          this.getData();
          this.$message.success("更新技能模型信息成功");
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.el-card {
  margin-bottom: 30px;
}
.basic-info {
  display: flex;
  margin-bottom: 12px;
  font-size: 14px;
  .label {
    display: inline-block;
    width: 90px;
    text-align: right;
  }
}
.flex {
  display: flex;
  font-size: 14px;
  line-height: 1.8;
  .flex-1 {
    flex: 1;
  }
  .flex-label {
    flex: none;
    width: 180px;
    text-align: right;
  }
}
.old-lace {
  background-color: rgba(253, 245, 230, 0.4);
}
.yellow {
  background-color: rgba(255, 255, 0, 0.2);
}
.light-green {
  background-color: rgba(144, 238, 144, 0.4);
}
.light-sky-blue {
  background-color: rgba(135, 206, 250, 0.4);
}
.violet {
  background-color: rgba(238, 130, 238, 0.4);
}
.deep-pink {
  background-color: rgba(255, 20, 147, 0.4);
}
.model-framework-container {
  .model-framework-btn {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 48px;
    .fullscreen-icon-container {
      display: inline-block;
      margin-left: 12px;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      vertical-align: middle;
      border: 1px solid #dcdfe6;
      border-radius: 50%;
      cursor: pointer;
      .fullscreen-icon {
        color: #606266;
      }
      &:hover {
        border-color: #0fc700;
        .fullscreen-icon {
          color: #0fc700;
        }
      }
    }
  }
  .model-framework-content {
    /deep/.el-table td {
      padding: 0 !important;
      .cell {
        padding: 0 !important;
        .cell-content {
          padding: 4px 14px;
        }
      }
    }
    .badge-status {
      display: inline-block;
      margin-right: 8px;
      width: 6px;
      height: 6px;
      vertical-align: middle;
      border-radius: 50%;
      &.success {
        background-color: #0fc700;
      }
      &.warning {
        background-color: #e6a23c;
      }
      &.info {
        background-color: #d9d9d9;
      }
    }
    .important_score-background {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }
    .important_score-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 4px 14px;
      width: 100%;
      height: 100%;
      text-align: center;
    }
  }
}
.dialog-info {
  padding: 0 48px;
  .dialog-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 12px;
    .dialog-item {
      position: relative;
      margin-bottom: 16px;
      padding-top: 12px;
      .dialog-item-delete {
        position: absolute;
        top: 10px;
        right: 10px;
        height: 0;
        overflow: hidden;
      }
      &:hover .dialog-item-delete {
        height: 14px;
      }
    }
  }
}
</style>
